module.exports = __webpack_public_path__ + "img/sudan-3.382619c3.png";